
import React, { useState, useEffect, useCallback } from "react";
import { toast } from "../../components/AppToast";
import { createRequestCycleCount } from "../../services/cyclecount/cyclecount";
import CommonDateInput from "../../components/CommonDateInput";

const emptyForm = {
    Owner_Start: "",
    Owner_End: "",
    Item_Start: "",
    Item_End: "",
    Locations_Start: "",
    Locations_End: "",
    Priority: 5,
    Request_Date: new Date().toISOString(),
    User: "",
    Host_Directed_Count: 0,
    Reference_Num: "",
    Reference_doc: "",
    Status: "",
    cyclecountkey: ""
};

// ⭐ Proper field order
const fieldOrder = [
    "Owner_Start",
    "Owner_End",
    "Item_Start",
    "Item_End",
    "Locations_Start",
    "Locations_End",
    "Priority",
    "Request_Date",
    "User",
    "Host_Directed_Count",
    "Reference_Num",
    "Reference_doc",
    "Status",
    "cyclecountkey"
];

export default function RequestCycleCount({
    initialValues,
    onCancel,
    onSubmit,
    viewOnly
}) {
    const [form, setForm] = useState(emptyForm);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (initialValues) {
            setForm({
                ...emptyForm,
                ...initialValues,
                Priority: Number(initialValues.Priority ?? 5),
                Host_Directed_Count: Number(initialValues.Host_Directed_Count ?? 0),
                Status: initialValues.Status || "",
                cyclecountkey: initialValues.cyclecountkey || ""
            });
        }
    }, [initialValues]);

    const handleChange = useCallback((e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            await createRequestCycleCount({
                ...form,
                Priority: Number(form.Priority),
                Host_Directed_Count: Number(form.Host_Directed_Count),
                Process_Flag: 0
            });

            toast.success("Cycle Count Request created");
            onSubmit?.();
        } catch (e) {
            toast.error("Failed to create request");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container">
            <div className="row gx-2">
                {fieldOrder.map((key) => {
                    // ⭐ Status only in view mode
                    if (key === "Status" && !viewOnly) return null;
                    if (key === "cyclecountkey" && !viewOnly) return null;

                    return (
                        <div className="col-md-2" key={key}>
                            <div className="form-group mb-3">
                                <label className="form-label">
                                    {key === "cyclecountkey"
                                        ? "Cycle Count Key"
                                        : key.replace(/_/g, " ")}
                                </label>

                                {key === "Request_Date" ? (
                                    <CommonDateInput
                                        name={key}
                                        value={form[key]}
                                        disabled={viewOnly}
                                        showTime
                                        onChange={handleChange}
                                    />
                                ) : key === "Host_Directed_Count" ? (
                                    <select
                                        className="form-select"
                                        disabled={viewOnly}
                                        value={form[key]}
                                        onChange={(e) =>
                                            setForm({
                                                ...form,
                                                Host_Directed_Count: Number(e.target.value)
                                            })
                                        }
                                    >
                                        <option value={1}>Yes</option>
                                        <option value={0}>No</option>
                                    </select>
                                ) : key === "Status" ? (
                                    <input
                                        className="form-control"
                                        value={form.Status}
                                        disabled
                                    />
                                ) : key === "cyclecountkey" ? (
                                    <input
                                        className="form-control"
                                        value={form.cyclecountkey}
                                        disabled
                                    />
                                ) : (
                                    <input
                                        className="form-control"
                                        name={key}
                                        value={form[key]}
                                        disabled={viewOnly}
                                        onChange={handleChange}
                                    />
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>

            <div className="text-center mt-4">
                <button className="btn btn-secondary me-2" onClick={onCancel}>
                    Back
                </button>

                {!viewOnly && (
                    <button
                        className="btn btn-primary"
                        disabled={loading}
                        onClick={handleSubmit}
                    >
                        {loading ? "Saving..." : "Create Request"}
                    </button>
                )}
            </div>
        </div>
    );
}
